<template>
	<div class="textarea-notes">
		<div v-if="contentSet.length > 0" style="height: 200px; overflow-y: auto;">
			<div v-for="qNote in contentSet" :key="qNote.questionMark">
				<Textarea
					class="page-note"
					:value="qNote.n"
					:autoResize="true"
					rows="1"
					@change="editHandler(qNote.questionMark, $event.target.value)"
				/>
				<!--<Divider />-->
			</div>
			<div class="other-notes-wrapper">
				<Textarea
					id="textarea"
					class="textarea-notes-input"
					:value="row[thead.name]"
					rows="2"
					placeholder="Enter additional notes..."
					:autoResize="true"
					@change="updateNotes($event.target.value)"
				/>
			</div>
		</div>
		<Textarea
			v-else
			type="text"
			class="textarea-notes"
			:value="row[thead.name]"
			:autoResize="false"
			rows="2"
			v-on:change="updateNotes($event.target.value)"
		/>
		<!--<el-button
			class="button-notes"
			icon="el-icon-edit"
			size="mini"
			circle
		></el-button>-->
	</div>
</template>
<script>
import Textarea from "primevue/textarea";
//import Divider from "primevue/divider";
export default {
	components: {
		Textarea,
		//Divider
	},
	props: {
		row: {},
		thead: {}
	},
	computed: {
		contentSet: {
			get() {
				let cs = this.$tera.project.commentSet?.find(
					cs => cs.mark === this.row["pageMark"]
				);
                        if (cs && cs.notes) {
                              console.log("Found notes:", Object.entries(cs.notes).map(([key, value]) => ({
						questionMark: key,
						n: value
					})));
					return Object.entries(cs.notes).map(([key, value]) => ({
						questionMark: key,
						n: value
					}));
				} else {
					return [];
				}
			}
		}
	},
	data() {
		return {
			//content: this.row[this.thead.name]
		};
	},
	methods: {
		editHandler(qm, e) {
			console.log("changeHandler:", qm, e);
			let cs = this.$tera.project.commentSet?.find(
				cs => cs.mark === this.row["pageMark"]
			);
			cs.notes[qm] = e;
		},
		updateNotes(newValue) {
			this.$set(this.row, this.thead.name, newValue);
			this.$emit("notes", newValue);
		}
	}
};
</script>
<style scoped>
div.textarea-notes {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100% !important;
	height: 100% !important;
	display: flex !important;
	flex-direction: column !important;
}

textarea.textarea-notes {
	width: 100% !important;
	height: 100% !important;
	flex-grow: 1 !important;
	resize: none !important;
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-color: #cbd5e1 transparent;
}

textarea.textarea-notes::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}
textarea.textarea-notes::-webkit-scrollbar-track {
	background: transparent;
}
textarea.textarea-notes::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 3px;
}
textarea.textarea-notes::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

.page-note {
	border-bottom: 1px solid #e2e8f0 !important;
	width: 100% !important;
	margin-bottom: 12px !important;
	padding-bottom: 8px !important;
}

.other-notes-wrapper {
	margin-top: 12px;
	border-top: 1px dashed #cbd5e1;
	padding-top: 10px;
	position: relative;
}

.textarea-notes-input {
	width: 100% !important;
	border: 1px solid #e2e8f0 !important;
	border-radius: 8px !important;
	padding: 10px 12px !important;
	font-size: 0.875rem !important;
	background: #f8fafc !important;
	transition: all 0.2s ease !important;
	box-sizing: border-box;
}

.textarea-notes-input:focus {
	border-color: #3b82f6 !important;
	background: #ffffff !important;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
	outline: none !important;
}
</style>
